import React from 'react';

function ThirthPage() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Thirth Page</h1>
      <p>Burası üçüncü sayfa (/thirt-page).</p>
    </div>
  );
}

export default ThirthPage;
